import { getBaseURL } from "../Utils/AuthUtil";
import { getOneMonthBeforeDate, formatDateToYYYYMMDD } from "../Utils/DateUtil";
import { getAuthorization } from "../Utils/AuthUtil";
import { GEOLOCATION_DATA } from "../Utils/Constant";
export const fetchVehicleData = async (setData, setLoading) => {
  const url = new URL(window.location.href);
  const collateralID = url.searchParams.get("collateralId");
  let startDate = url.searchParams.get("startDate");
  let endDate = url.searchParams.get("endDate");
  let payload = {
    collateralId: Number(collateralID),
    fromDate: startDate,
    toDate: endDate,
  };
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getAuthorization(),
    },
    body: JSON.stringify(payload),
    mode: "cors",
  };
  try {
    setLoading(true);
    const response = await fetch(
      getBaseURL() + GEOLOCATION_DATA,
      requestOptions
    );

    if (response.ok) {
      const result = await response.json();
      setData(result);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    window.alert(error);
  } finally {
    setLoading(false);
  }
};
